import { render, staticRenderFns } from "./CustomerDetailHeader.vue?vue&type=template&id=001eb006&lang=pug&"
import script from "./CustomerDetailHeader.vue?vue&type=script&lang=js&"
export * from "./CustomerDetailHeader.vue?vue&type=script&lang=js&"
import style0 from "./CustomerDetailHeader.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports